export { default } from './PartiuGpNumerosDaSorte';
